<template>
 <div id="notifyalert">
    <!--
      Alert 
    type="success"
    type="info"
    type="warning"
    type="error" 
    -->
  <template>
    <div id="alertApp">
      <!-- close-text="Close Alert" -->
      <v-alert
        :value="alert"
        transition="scale-transition"        
        icon="warning"
        type="warning"
        prominent
        >
        <v-row
          no-gutters         
        >
          <v-col>
            {{ newnotify.name }} 
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-btn
              @click="UpdateStatus(newnotify.id)"
              color="deep-dark"          
            >
            Leido
          </v-btn>
        </v-col>
      </v-row>
      </v-alert>
    </div>
  </template>
    
 </div>
</template>


<script>
// {{ row.fecha_inicio }} - {{ row.fecha_fin }} <br>
//           
//            <br><br>
// import axios from "axios";
// import{ mapMutations } from "vuex";
import{ mapMutations,mapState } from "vuex";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router'


export default{
  name: "notify",  
  computed:{
        ...mapState(['notifications'])
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    listenForNotifications() {
      const channel = this.$pusher.subscribe('notifications');
      channel.bind('App\\Events\\NotificationCreated', (data) => {
        this.notifications.push(data.notification);
        this.newnotify=data.notification;
        this.alert=true;
      });
    },
    // UpdateStatusKardex(id){
    //   // alert('entro'+id); id es de branch_id
    //   console.log(id);
      // this.alert=false;
    // },
    async UpdateStatus(id){
      // alert("Estoy aqui"+id)
      try{        
            this.showLoading({titulo:"Accediendo información",color:"warning"})        
            icheckApi().post(`/eventos/update/${id}`,JSON.stringify({'status':'Finalizado'})).then((response)=>{
                if(!response.data.error){                            
                  this.$swal("Genial!",response.data.message, "success");
                }else{
                  this.$swal("Error!",response.data.message, "error");
                }                                    
              });                                                                                                    
            // console.log("VENTA: "+response.data.message);
      }catch(error){
        // console.log('Notify Update '+error);
      }  finally{
            this.hiddenLoading()
            this.alert=false;
            // this.$swal("Genial!", "Se actualizó la información", "success");
      }
    }
  },
  data(){
    return{
        revents:null,
        alert:false,
        newnotify:[]
    }
  },
  created(){
    this.listenForNotifications();
  } 
}
</script>
<style>
#alertApp,.v-alert{
  margin-bottom:0px;
}
  
</style>